// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__fiSVs","inner":"style_inner__3D3V6","bottom":"style_bottom__3KCSZ","copyright":"style_copyright__2q1Nj"};